import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import se from "./translations/se/translation_se.json";
import en from "./translations/en/translation_en.json";
import ee from "./translations/ee/translation_ee.json";
import fi from "./translations/fi/translation_fi.json";
import lt from "./translations/lt/translation_lt.json";
import lv from "./translations/lv/translation_lv.json";
import no from "./translations/no/translation_no.json";
import piri from "./translations/piristeel/translation_piri.json";

import LanguageDetector from 'i18next-browser-languagedetector';


i18n
 
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    resources: {
        en: {
            trans: en              
        },
        se: {
            trans: se
        },
        ee: {
            trans: ee
        },
        fi: {
            trans: fi
        },
        lt: {
            trans: lt
        },
        lv: {
            trans: lv
        },
        no: {
            trans: no
        },
        piristeel: {
            trans: piri
        },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;




